import { Table, Tag } from "antd";
import moment from "moment";

export const TableDevice = ({ t, dataTable }) => {
  const fontSize = {
    fontSize: "16px",
  };

  const columns = [
    {
      title: t("metrics.tableDevice.deviceName"),
      dataIndex: "name",
      key: "name",
      render: (text = "") => (
        <Tag color="blue" style={fontSize}>
          {text.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: t("metrics.tableDevice.devEui"),
      dataIndex: "devEui",
      key: "devEui",
      render: (text = "") => (
        <Tag color="blue" style={fontSize}>
          {text.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: t("metrics.tableDevice.creationDate"),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text = "") => (
        <Tag color="blue" style={fontSize}>
          {moment(text).format("DD-MM-YYYY HH:mm")}
        </Tag>
      ),
    },
  ];

  return (
    <Table
      scroll={{ x: "calc(200px + 50%)" }}
      className="hover-off"
      columns={columns}
      dataSource={dataTable}
      pagination={false}
    ></Table>
  );
};
